import { Token } from '@stitches/react/types/theme'

import { globalCss, theme } from './stitches.config'

export const uiCommon = {
  buttonReset: {
    all: 'unset',
    cursor: 'pointer',
    boxSizing: 'border-box',
    border: 'none',
    backgroundColor: 'transparent',
    margin: 0,
    padding: 0
  },
  globalCSS: globalCss({
    html: {
      height: '100%',
      width: '100%',
      backgroundColor: theme.colors.ui_neutral01
    },
    body: {
      height: '100%',
      width: '100%',
      color: theme.colors.ui_neutral07,
      fontSize: 14
    }
  }),
  paragraphReset: {
    margin: 0,
    padding: 0
  },
  scrollBars: ({
    backgroundColor = 'transparent',
    handleColor = theme.colors.ui_neutral03.computedValue,
    hoverColor = theme.colors.ui_neutral04.computedValue
  }: {
    backgroundColor?: Token['computedValue'] | 'transparent'
    handleColor?: Token['computedValue']
    hoverColor?: Token['computedValue']
  }) => {
    return {
      // FF
      scrollbarWidth: `thin`,
      scrollbarColor: `${handleColor} ${backgroundColor}`,

      // Chrome, Edge, and Safari
      '&::-webkit-scrollbar': {
        width: 4,
        height: 4
      },
      '&::-webkit-scrollbar-track': {
        background: backgroundColor
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: handleColor,
        borderRadius: 4,

        '&:hover': {
          backgroundColor: hoverColor
        }
      }
    }
  },
  transitions: {
    authenticMotion: 'cubic-bezier(0.4, 0, 0.2, 1)'
  }
}
